import "./services/setupInterceptors"; // must run before any service creates an axios instance
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import  ThemeContext  from "./context/ThemeContext";
import { BrandingProvider } from "./context/BrandingContext";
import SeoManager from "./jsx/components/Seo/SeoManager";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store = {store}>
      <BrowserRouter>
        <BrandingProvider>
          <ThemeContext>
            <SeoManager />
            <App />
          </ThemeContext>
        </BrandingProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
